import { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import { LibraryBooks, Code, Search, EmojiObjects, Widgets, Web, Home, Assessment } from '@material-ui/icons';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { useApi, configApiRef } from '@backstage/core-plugin-api';

const useSidebarLogoStyles = makeStyles({
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: 92,
    background: '#071D41'
  },
  link: {
    width: sidebarConfig.drawerWidthOpen,
    marginLeft: 24,
  },
  sidebar: {
    backgroud: '#FFF'
  },
  searchbar: {
    margin: 16,
    marginBottom: 0,

    "& button": {
      width: "224px !important"
    }
  }
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.header}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => {
  const config = useApi(configApiRef);
  const showcaseOlimpiaUrl = config.getOptionalString("app.showcaseOlimpiaUrl") || "";
  const dashboardMonitorUrl = config.getOptionalString("app.dashboardMonitorUrl") || "";
  const apiOlimpiaUrl = config.getOptionalString("app.apiOlimpiaUrl") || '/api-docs';
  
  return (
    <SidebarPage>
      <Sidebar >
        <SidebarLogo />
        <SidebarGroup label="O que você procura?" icon={<Search />} to="/search">
          <div className={useSidebarLogoStyles().searchbar}>
            <SidebarSearchModal />
          </div>
        </SidebarGroup>
        <SidebarDivider />
        <SidebarGroup label="Menu" icon={<MenuIcon />}>
          {/* Global nav, not org-specific */}
          <SidebarItem icon={Home} to="/" text="Home" />
          <SidebarItem icon={Widgets} to="catalog" text="Catálogo" />
          <SidebarItem icon={Code} to={apiOlimpiaUrl} target="_blank" text="APIs" />
          <SidebarItem icon={LibraryBooks} to="docs/default/resource/techdocs-docs" text="Documentações" />
          <SidebarItem icon={Web} to="create" text="Templates" />
          <SidebarItem icon={EmojiObjects} to={showcaseOlimpiaUrl} target="_blank" text="Showcase" />
          <SidebarItem icon={Assessment} to={dashboardMonitorUrl} target="_blank" text="Monitoramento" />
          {/* End global nav */}
          <SidebarDivider />
          <SidebarScrollWrapper>
            {/* Items in this group will be scrollable if they run out of space */}
          </SidebarScrollWrapper>
        </SidebarGroup>
        <SidebarSpace />
        <SidebarDivider />
        <SidebarGroup
          label="Configurações"
          icon={<UserSettingsSignInAvatar />}
          to="/settings"
        >
          <SidebarSettings />
        </SidebarGroup>
      </Sidebar>
      {children}
    </SidebarPage>
  )
};
